const footerLinksData = [
    {
        title: 'أفضل الوجهات',
        items: [
            {
                href: 'https://sa.wingie.com/flights/to-dubai/',
                title: 'دبي',
            },
            {
                href: 'https://sa.wingie.com/flights/to-abu-dhabi/',
                title: 'أبو ظبي',
            },
            {
                href: 'https://sa.wingie.com/flights/to-sharjah/',
                title: 'الشارقة',
            },
            {
                href: 'https://sa.wingie.com/flights/to-manila/',
                title: 'مانيلا',
            },
            {
                href: 'https://sa.wingie.com/flights/to-lahore/',
                title: 'لاهور',
            },
            {
                href: 'https://sa.wingie.com/flights/to-islamabad/',
                title: 'إسلام أباد',
            },
        ],
    },
    {
        title: 'أشهر الدول',
        items: [
            {
                href: 'https://sa.wingie.com/flights/az-azerbaijan/',
                title: 'أذربيجان',
            },
            {
                href: 'https://sa.wingie.com/flights/bh-bahrain/',
                title: 'البحرين',
            },
            {
                href: 'https://sa.wingie.com/flights/eg-egypt/',
                title: 'مصر',
            },
            {
                href: 'https://sa.wingie.com/flights/in-india/',
                title: 'الهند',
            },
            {
                href: 'https://sa.wingie.com/flights/jo-jordan/',
                title: 'الأردن',
            },
            {
                href: 'https://sa.wingie.com/flights/ke-kenya/',
                title: 'كينيا',
            },
        ],
    },
    {
        title: 'أشهر الخطوط الجوية',
        items: [
            {
                href: 'https://sa.wingie.com/flights/airlines/emirates/',
                title: 'الإمارات',
            },
            {
                href: 'https://sa.wingie.com/flights/airlines/etihad-airways/',
                title: 'شَرِكَة ٱلْاِتِّحَاد لِلطَّيْرَان',
            },
            {
                href: 'https://sa.wingie.com/flights/airlines/flydubai/',
                title: 'فلاي دبي',
            },
            {
                href: 'https://sa.wingie.com/flights/airlines/air-arabia/',
                title: 'العربية للطيران',
            },
            {
                href: 'https://sa.wingie.com/flights/airlines/turkish-airlines/',
                title: 'الخطوط الجوية التركية',
            },
            {
                href: 'https://sa.wingie.com/flights/airlines/egyptair/',
                title: 'مصر للطيران',
            },
        ],
    },
]

export default footerLinksData
